import type {SelectOptions} from 'src/components/lib/select/select';

import * as React from 'react';
import {useDispatch} from 'react-redux';

import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {classify} from 'src/utils/classify';
import {
  setFallbackNumberForCategory,
  getCategoryDetails,
} from 'src/action-creators/content-subscription';
import {popModal} from 'src/action-creators/modal';
import Select from 'src/components/lib/select/select';
import Button from 'src/components/lib/new-button';

import css from './default-number-for-category-modal.css';


export default function DefaultNumberForCategory({
  options,
  categoryId,
}: {
  options: SelectOptions<string>;
  categoryId: number;
}) {
  const {t} = useLabelTranslation();
  const [selectedFallbackNumber, setSelectedFallbackNumber] =
    React.useState<any>();
  const dispatch = useDispatch();
  const close = () => dispatch(popModal());
  const onMakeDefault = async () => {
    if (selectedFallbackNumber?.value) {
      await dispatch(
        setFallbackNumberForCategory(categoryId, selectedFallbackNumber.value),
      );
      try {
        await dispatch(getCategoryDetails(String(categoryId)));
      } catch (error: any) {
        console.log('Error getting category details:', error);
      }

      close();
    }
  };

  return (
    <div className={classify(css.container)}>
      <div className={css.header}>
        <div className={css.title}>
          {t(
            'Select_a_fallback_number_for_category',
            'Select a fallback number for category',
          )}
        </div>
      </div>

      <div className={css.form}>
        <span className={css.description}>
          {t(
            'Fallback_numbers_helps_to_send_SMS_in_case_Agency_numbers_are_not_available_You_can_only_select_a_fallback_number_from_Agency_Variable_Number_s_and_Agency_Default_Number',
            'Fallback numbers helps to send SMS, in case Agency numbers are not available. You can only select a fallback number from Agency Variable Number (s) and Agency Default Number',
          )}
        </span>
        {/* @ts-expect-error - TS2769 - No overload matches this call. */}
        <Select
          className={css.select}
          placeholder={t('Select_a_phone_number', 'Select a phone number')}
          options={options}
          value={selectedFallbackNumber ?? null}
          onChange={(val) => val && setSelectedFallbackNumber(val)}
        />
      </div>

      <div className={css.menu}>
        <Button className={css.cancelButton} onClick={close}>
          {t('Cancel', 'Cancel')}
        </Button>
        <Button
          className={css.nextButton}
          onClick={onMakeDefault}
          type="primary"
        >
          {t('Set_fallback', 'Set fallback')}
        </Button>
      </div>
    </div>
  );
}
